import React, { useEffect, useState, useRef, useCallback } from 'react';
import { CloseRounded } from '@material-ui/icons';
import styles from './styles';
import { Tooltip, Button } from '@material-ui/core';
import Select from 'react-select';
import TimePicker from 'rc-time-picker';
import {
  createScheduler,
  getAchedulerList,
  getUserCred,
  removeAchedulerList,
  resetFailures,
  updateScheduler,
  SaveApiResMessage,
} from '@/actions';
import { useNotify } from 'react-admin';
import { capitalize } from 'lodash';
import moment from 'moment';
import { fTimeDate } from '@/actions/Helper';
import LoadingV2 from '@/components/Loading';
import { formatDateTimeToUTC } from '@/ctUtlis/formatDate';

export default ({ Close, DATA, settingId, idx }) => {
  const cls = styles();
  const wrapperRef = React.useRef(null);

  const notify = useNotify();
  const [loading, setLoading] = React.useState(false);
  const [loadingData, setLoadingData] = React.useState(false);

  const [name, setSchedulerName] = useState('');
  const [scheduler_id, setScheduler_id] = useState('');
  const [credis, setCredis] = useState();
  const [selectedCred, setSelectedCred] = useState(null);
  const [mode, setMode] = useState(null);
  const [schedulers, setSchedulers] = useState();
  const [user_credi_id, setCompany] = useState('');
  const [username, setUsername] = useState('MARCELLO');
  const [password, setPassword] = useState('');
  const [frequency, setRepeatEvery] = useState(6);
  const [frequencyType, setRepeatEveryType] = useState();
  const [start_time, setTimeStart] = useState(moment('00:01:00', 'h:mm a'));
  const [end_time, setTimeEnd] = useState(moment('23:59:00', 'h:mm a'));
  const [selectedDays, setSelectedDays] = useState({
    sat: 0,
    sun: 0,
    mon: 0,
    tue: 0,
    wed: 0,
    thu: 0,
    fri: 0,
  });
  const [active, setActive] = useState(false);
  const [last_failed, setLastFailed] = useState('');
  const [failed_count, setFailedCount] = useState('');
  const [last_scraped_at, setLastScrapedAt] = useState('');
  const getTimeString = (dateString) => {
    const date = new Date(dateString);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const formattedCredis = [
    {
      label: 'Custom Credential',
      value: 'nocreds',
    },
    ...(credis && Array.isArray(credis)
      ? credis.map((item) => ({
          label: item.company,
          value: item.id,
          // value: item.company.replace(/\s+/g, ''),
        }))
      : []),
  ];

  const ferequencyOptions = [
    {
      label: 'Hours',
      value: 'hours',
    },
    {
      label: 'Minutes',
      value: 'minutes',
    },
    {
      label: 'Days',
      value: 'days',
    },
  ];

  const handleDayClick = (day) => {
    setSelectedDays((prevState) => ({
      ...prevState,
      [day]: prevState[day] === 0 ? 1 : 0,
    }));
  };

  const handleSave = () => {
    const formData = {
      name,
      user_credi_id,
      username,
      password,
      scrape_setting_id: DATA.id,
      frequency,
      frequencyType: frequencyType?.value ? frequencyType.value : frequencyType,
      start_time: getTimeString(start_time),
      end_time: getTimeString(end_time),
      sat: selectedDays.sat,
      sun: selectedDays.sun,
      mon: selectedDays.mon,
      tue: selectedDays.tue,
      wed: selectedDays.wed,
      thu: selectedDays.thu,
      fri: selectedDays.fri,
      last_failed: last_failed,
      failed_count: failed_count,
      status: active ? 'ACTIVE' : 'INACTIVE',
    };

    // Validation for required fields
    const requiredFields = {
      name: 'Scheduler Name',
      user_credi_id: 'Company',
      frequency: 'Repeat Every',
      frequencyType: 'Frequency Type',
      start_time: 'Start Time',
      end_time: 'End Time',
    };

    // Add username and password to required fields only if user_credi_id is 'nocreds'
    if (formData.user_credi_id === 'nocreds') {
      requiredFields.username = 'Username';
      requiredFields.password = 'Password';
    }

    const emptyFields = Object.entries(requiredFields)
      .filter(([key]) => {
        const value = formData[key];
        return !value || value === '' || value === null || value === undefined;
      })
      .map(([_, label]) => label);

    if (emptyFields.length > 0) {
      // notify(
      //   `Please fill in the following fields: ${emptyFields.join(', ')}`,
      //   'warning'
      // );
      SaveApiResMessage({
        title: 'Warning',
        message: `Please fill in the following fields: ${emptyFields.join(
          ', '
        )}`,
        mode: 'warning',
      });
      return;
    }

    // Additional validation for frequency (must be positive number)
    if (parseInt(frequency) <= 0) {
      // notify('Repeat Every must be a positive number', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'Repeat Every must be a positive number',
        mode: 'warning',
      });
      return;
    }

    // Validation for selectedDays (at least one day must be selected)
    const allDaysZero = Object.values(selectedDays).every((day) => day === 0);
    if (allDaysZero) {
      // notify('Please select at least one day of the week', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'Please select at least one day of the week',
        mode: 'warning',
      });
      return;
    }

    createScheduler(formData)
      .then((res) => {
        handleGetAchedulerList();
        setSelectedCred(schedulers.length);
        setMode('update');
        // notify('Successfully Created!', 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Successfully Created!',
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const handleUpdate = () => {
    const formData = {
      scheduler_id: scheduler_id,
      name,
      user_credi_id: user_credi_id?.value ? user_credi_id.value : user_credi_id,
      username,
      password,
      frequency,
      frequencyType: frequencyType?.value ? frequencyType.value : frequencyType,
      start_time: getTimeString(start_time),
      end_time: getTimeString(end_time),
      sat: selectedDays.sat,
      sun: selectedDays.sun,
      mon: selectedDays.mon,
      tue: selectedDays.tue,
      wed: selectedDays.wed,
      thu: selectedDays.thu,
      fri: selectedDays.fri,
      last_failed: last_failed,
      failed_count: failed_count,
      status: active ? 'ACTIVE' : 'INACTIVE',
    };

    // Validation for required fields
    const requiredFields = {
      name: 'Scheduler Name',
      user_credi_id: 'Company',
      frequency: 'Repeat Every',
      frequencyType: 'Frequency Type',
      start_time: 'Start Time',
      end_time: 'End Time',
    };

    // Add username and password to required fields only if user_credi_id is 'nocreds'
    if (formData.user_credi_id === 'nocreds') {
      requiredFields.username = 'Username';
      requiredFields.password = 'Password';
    }

    const emptyFields = Object.entries(requiredFields)
      .filter(([key]) => {
        const value = formData[key];
        return !value || value === '' || value === null || value === undefined;
      })
      .map(([_, label]) => label);

    if (emptyFields.length > 0) {
      // notify(
      //   `Please fill in the following fields: ${emptyFields.join(', ')}`,
      //   'warning'
      // );
      SaveApiResMessage({
        title: 'Warning',
        message: `Please fill in the following fields: ${emptyFields.join(
          ', '
        )}`,
        mode: 'warning',
      });
      return;
    }

    // Additional validation for frequency (must be positive number)
    if (parseInt(frequency) <= 0) {
      // notify('Repeat Every must be a positive number', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'Repeat Every must be a positive number',
        mode: 'warning',
      });
      return;
    }

    // Validation for selectedDays (at least one day must be selected)
    const allDaysZero = Object.values(selectedDays).every((day) => day === 0);
    if (allDaysZero) {
      // notify('Please select at least one day of the week', 'warning');
      SaveApiResMessage({
        title: 'Warning',
        message: 'Please select at least one day of the week',
        mode: 'warning',
      });
      return;
    }

    updateScheduler(formData)
      .then((res) => {
        handleGetAchedulerList();
        // notify('Successfully Updated!', 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Successfully Updated!',
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };
  const handleResetFailures = () => {
    resetFailures(scheduler_id)
      .then((res) => {
        handleGetAchedulerList(scheduler_id);
        // notify('Successfully Reset!', 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Successfully Reset!',
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };
  const handleRemove = () => {
    removeAchedulerList(schedulers[selectedCred].id)
      .then((res) => {
        handleGetAchedulerList();
        setMode(null);
        setSelectedCred(null);
        // notify('Successfully Created!', 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Successfully Created!',
          mode: 'success',
        });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const handleShowScheduler = (index) => {
    setLoadingData(true);
    setMode('update');
    if (schedulers) {
      setSelectedCred(index);
      setSchedulerName(schedulers[index]?.name);
      setScheduler_id(schedulers[index]?.id);
      setActive(schedulers[index]?.status === 'ACTIVE' ? true : false);
      setLastFailed(schedulers[index]?.last_failed);
      setFailedCount(schedulers[index]?.failed_count);
      console.log(schedulers[index]?.last_scraped_at);
      setLastScrapedAt(schedulers[index]?.last_scraped_at);
      setCompany({
        label: schedulers[index]?.user?.company
          ? schedulers[index]?.user?.company
          : 'Custom Credential',
        value:
          schedulers[index]?.user_credential_id !== null
            ? schedulers[index]?.user_credential_id
            : 'nocreds',
      });
      setUsername(
        schedulers[index]?.user_credential?.relation_user
          ? schedulers[index]?.user_credential?.relation_user
          : schedulers[index]?.username
      );
      setPassword(
        schedulers[index]?.user_credential?.relation_pass
          ? schedulers[index]?.user_credential?.relation_pass
          : schedulers[index]?.password
      );
      setRepeatEvery(schedulers[index]?.frequency);
      setRepeatEveryType(
        schedulers[index]?.frequency_type === 'minutes'
          ? ferequencyOptions[1]
          : schedulers[index]?.frequency_type === 'hours'
          ? ferequencyOptions[0]
          : schedulers[index]?.frequency_type === 'days'
          ? ferequencyOptions[2]
          : ''
      );
      setTimeStart(moment(schedulers[index]?.start_time, 'h:mm a'));
      setTimeEnd(moment(schedulers[index]?.end_time, 'h:mm a'));
      setSelectedDays({
        sat: schedulers[index]?.sat,
        sun: schedulers[index]?.sun,
        mon: schedulers[index]?.mon,
        tue: schedulers[index]?.tue,
        wed: schedulers[index]?.wed,
        thu: schedulers[index]?.thu,
        fri: schedulers[index]?.fri,
      });
    }
    setTimeout(() => {
      setLoadingData(false);
    }, 300);
  };

  const handleNewScheduler = (index) => {
    setMode('new');
    setSelectedCred(null);

    setSchedulerName('');
    setCompany('');
    setUsername('');
    setPassword('');
    setRepeatEvery('60');
    setRepeatEveryType(ferequencyOptions[0]);
    setTimeStart(moment('00:01:00', 'h:mm a'));
    setTimeEnd(moment('23:59:00', 'h:mm a'));
    setSelectedDays({
      sat: 0,
      sun: 0,
      mon: 0,
      tue: 0,
      wed: 0,
      thu: 0,
      fri: 0,
    });
    setActive(true);
    setLastFailed('');
    setFailedCount('');
    setLastScrapedAt('');
  };

  const handleGetAchedulerList = (scheduler_id) => {
    setLoading(true);
    getAchedulerList(settingId)
      .then((res) => {
        const currentSchedular = res?.data?.schedulers?.find(
          (el) => el.id === scheduler_id
        );

        setCredis(res?.data?.credis);
        setSchedulers(res?.data?.schedulers);
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };
  const handleGetUserCred = (id) => {
    if (id === 'nocreds') {
      setPassword(schedulers[selectedCred]?.password || '');
      setUsername(schedulers[selectedCred]?.username || '');
      return;
    } // setLoading(true);
    getUserCred(id)
      .then((res) => {
        setPassword(res?.data?.credi?.relation_pass);
        setUsername(res?.data?.credi?.relation_user);
        // setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        // setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAchedulerList();
  }, []);

  useEffect(() => {
    if (schedulers && schedulers.length !== 0) {
      setSelectedCred(0);
      handleShowScheduler(0);
    }
  }, [schedulers]);

  return (
    <div
      id="app_modal"
      // onClick={(e) => e.target.id === 'app_modal'}
      className={cls.popup}>
      <div className={cls.AddSchedulerpopupCard}>
        <>
          <Tooltip arrow title="Close" placement="top">
            <CloseRounded className={cls.closeP} onClick={Close} />
          </Tooltip>

          <div ref={wrapperRef} className={cls.AddSchedulerpopupBody}>
            <span className={cls.tableTopActions}>
              {/* <ReactSVG
                  src={Icons.containerTruck}
                  className={cls.dicsounticon}
                /> */}
              Custom Scheduler
            </span>

            <div className={cls.containerScheduler}>
              <div className={cls.containerSchedulerLeft}>
                {/* <span
                onClick={(e) => handleNewScheduler(idx)}
                className={cls.headerScheduler}>
                New Scheduler
              </span> */}
                {loading ? (
                  <div className="mt-16">
                    <LoadingV2 />
                  </div>
                ) : (
                  schedulers?.map((item, idx) => (
                    <span
                      onClick={(e) => handleShowScheduler(idx)}
                      className={
                        selectedCred === idx
                          ? cls.selectedHeaderScheduler
                          : cls.headerScheduler
                      }>
                      {item.name}
                    </span>
                  ))
                )}
              </div>
              <div className={cls.containerSchedulerRight}>
                {loadingData ? (
                  <div className="mt-16">
                    <LoadingV2 />
                  </div>
                ) : mode === 'new' || mode === 'update' ? (
                  <div className={cls.contentWrapper}>
                    <div className={cls.NameSchedulerSection}>
                      <div className={cls.schedulerHeader}>
                        <label className={cls.labelScheduler}>
                          Scheduler Name
                        </label>
                        <input
                          className={cls.inputScheduler}
                          type="text"
                          value={name}
                          onChange={(e) => setSchedulerName(e.target.value)}
                        />
                      </div>
                      <div className={cls.schedulerHeader}>
                        <label>
                          Active
                          <input
                            className={cls.checkboxScheduler}
                            type="checkbox"
                            checked={active}
                            onChange={() => setActive((pre) => !pre)}
                          />
                        </label>
                      </div>
                    </div>
                    <div className={cls.userSchedulerSection}>
                      <label className={cls.labelScheduler}>User Account</label>
                      <div className={cls.userAccount}>
                        <span className={cls.userCredsSpan}>
                          <label className={cls.labelSchedulerUser}>
                            Company
                          </label>
                          <Select
                            // isClearable
                            placeholder="Type"
                            className={cls.selectSchedulerCompany}
                            onChange={(e) => {
                              handleGetUserCred(e.value);
                              setCompany(e.value);
                            }}
                            defaultValue={user_credi_id}
                            // value={user_credi_id}
                            // onChange={(item) => {
                            //   handleSelectSizeTypeModel(item);
                            // }}
                            options={formattedCredis}
                          />
                        </span>
                        <span className={cls.userCredsSpan}>
                          <label className={cls.labelSchedulerUser}>
                            Username
                          </label>
                          <input
                            disabled={
                              user_credi_id === 'nocreds' ||
                              user_credi_id.value === 'nocreds'
                                ? false
                                : true
                            }
                            className={cls.inputScheduler}
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </span>
                        <span className={cls.userCredsSpan}>
                          <label className={cls.labelSchedulerUser}>
                            Password
                          </label>
                          <input
                            disabled={
                              user_credi_id === 'nocreds' ||
                              user_credi_id.value === 'nocreds'
                                ? false
                                : true
                            }
                            className={cls.inputScheduler}
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </span>
                      </div>
                    </div>
                    <div className={cls.repeatSection}>
                      <div className={cls.repeatTime}>
                        <label className={cls.labelRepeatScheduler}>
                          Repeat Every
                        </label>
                        <input
                          className={cls.numberInputScheduler}
                          type="number"
                          value={frequency}
                          onChange={(e) => setRepeatEvery(e.target.value)}
                        />
                        <Select
                          // isClearable
                          placeholder="Type"
                          className={cls.selectSchedulerTimeType}
                          onChange={(e) => {
                            setRepeatEveryType(e.value);
                          }}
                          defaultValue={frequencyType}
                          // value={user_credi_id}
                          // onChange={(item) => {
                          //   handleSelectSizeTypeModel(item);
                          // }}
                          options={ferequencyOptions}
                        />
                      </div>
                      <div className={cls.repeatTime}>
                        <label className={cls.labelRepeatScheduler}>
                          Between
                        </label>
                        <TimePicker
                          className={cls.inputTimeScheduler}
                          value={start_time || ''}
                          onChange={(time) => {
                            setTimeStart(time);
                          }}
                          showSecond={false}
                          format="hh:mm A"
                          allowEmpty
                        />
                        {/* <input
                          className={cls.inputScheduler}
                          type="text"
                          value={start_time}
                          onChange={(e) => setTimeStart(e.target.value)}
                        /> */}
                        <span className={cls.labelScheduler}>&</span>
                        <TimePicker
                          className={cls.inputTimeScheduler}
                          value={end_time || ''}
                          onChange={(time) => {
                            setTimeEnd(time);
                          }}
                          showSecond={false}
                          format="hh:mm A"
                          allowEmpty
                        />
                        {/* <input
                          className={cls.inputScheduler}
                          type="text"
                          value={end_time.slice(0, 5)}
                          onChange={(e) => setTimeEnd(e.target.value)}
                        /> */}
                      </div>
                    </div>
                    <div className={cls.deySelectSection}>
                      <div className={cls.daysOfWeek}>
                        <label className={cls.labelScheduler}>
                          Days of the Week
                        </label>
                        <div className={cls.dayButtons}>
                          {Object.keys(selectedDays).map((day) => (
                            <button
                              key={day}
                              className={
                                selectedDays[day] === 1
                                  ? cls.activeDayButton
                                  : cls.dayButton
                              }
                              onClick={() => handleDayClick(day)}>
                              {capitalize(day)}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className={cls.deySelectSection}>
                      <div className={cls.daysOfWeek}>
                        <label className={cls.labelScheduler}>
                          Failure Message
                        </label>
                        <div className={cls.failDiv}>
                          <span className={cls.fmessage}>
                            Last Failure:{' '}
                            {last_failed && formatDateTimeToUTC(last_failed)}
                          </span>
                          <span className={cls.fmessage}>
                            Consecutive Fails: {failed_count}
                          </span>
                        </div>
                        <div className={cls.failDiv}>
                          <span className={cls.fmessage}>
                            Last Scrape:{' '}
                            {last_scraped_at &&
                              formatDateTimeToUTC(last_scraped_at)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <span className={cls.selectOrAddMsgSpan}>
                    Select or add scheduler
                  </span>
                )}
              </div>
            </div>
            <div className={cls.schedulerActions}>
              <span className={cls.addRemoveBtn}>
                <Button
                  className={cls.actionButton}
                  onClick={(e) => handleNewScheduler(idx)}>
                  Add
                </Button>
                {mode === 'update' ? (
                  <Button
                    className={cls.actionButton}
                    onClick={() => handleRemove()}>
                    Remove
                  </Button>
                ) : (
                  ''
                )}
              </span>
              {mode === 'update' ? (
                <span style={{ display: 'flex', gap: 10 }}>
                  <Button
                    disabled={loadingData}
                    className={cls.saveButton}
                    onClick={handleResetFailures}>
                    Clear Counts
                  </Button>
                  <Button
                    disabled={loadingData}
                    className={cls.saveButton}
                    onClick={handleUpdate}>
                    Update
                  </Button>
                </span>
              ) : mode === 'new' ? (
                <Button
                  disabled={loadingData}
                  className={cls.saveButton}
                  onClick={handleSave}>
                  Save
                </Button>
              ) : (
                ''
              )}
            </div>
          </div>
        </>
      </div>
    </div>
  );
};
